module.exports = __webpack_public_path__ + "img/trumpet_icon.db5c62f9.png";